<div class="adx-settings-wrapper">
    <div class="adx-settings-dialog">

        <div class="adx-settings-header">
            <h2 class="adx-settings-title">
                {{ "ASTIMAX.VMAILBOX.WIDGET.VMAILBOX" | translate }} {{ "ASTIMAX.VMAILBOX.WIDGET.SETTINGS" | translate }}
            </h2>
            <button mat-icon-button
                    [mat-dialog-close]="true"
                    aria-label="Close Button"
                    class="adx-settings-close-btn"
                    matTooltip="{{ 'ASTIMAX.VMAILBOX.WIDGET.CLOSE' | translate }}">
                <fa-icon [icon]="'xmark'"></fa-icon>
            </button>
        </div>

        <div class="adx-settings-content">

            <!-- Widget title -->
            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ "ASTIMAX.VMAILBOX.WIDGET.WIDGET_TITLE" | translate }}</mat-label>
                    <input matInput
                           aria-label="Titel eingeben"
                           type="text"
                           [(ngModel)]="widgetTitle"
                           minlength="2"
                           maxlength="50">
                </mat-form-field>
            </div>

            <!-- Mailbox selection -->
            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ 'ASTIMAX.VMAILBOX.WIDGET.SETTING.MAILBOX' | translate }}</mat-label>

                    @if (isLoadingMailboxes) {
                        <mat-select [disabled]="true">
                            <mat-option>{{ 'ASTIMAX.VMAILBOX.WIDGET.LOADING' | translate }}</mat-option>
                        </mat-select>
                    } @else {
                        <mat-select [(ngModel)]="selectedMailboxNr" name="mailboxNr">
                            <!-- Deselect option — allows clearing a mailbox that was removed in Keycloak -->
                            <mat-option [value]="null">
                                <span class="adx-deselect-option">{{ 'ASTIMAX.VMAILBOX.WIDGET.SETTING.MAILBOX_NONE' | translate }}</span>
                            </mat-option>
                            @for (mailbox of availableMailboxes; track mailbox.nr) {
                                <mat-option [value]="mailbox.nr">{{ mailboxLabel(mailbox) }}</mat-option>
                            }
                        </mat-select>
                    }

                    @if (mailboxLoadError) {
                        <mat-hint>{{ 'ASTIMAX.VMAILBOX.WIDGET.SETTING.MAILBOX_LOAD_ERROR' | translate }}</mat-hint>
                    }
                    @if (availableMailboxes.length === 0 && !isLoadingMailboxes) {
                        <mat-hint>{{ 'ASTIMAX.VMAILBOX.WIDGET.SETTING.NO_MAILBOXES' | translate }}</mat-hint>
                    }

                </mat-form-field>
            </div>

            <!-- Widget header display -->
            <div class="adx-form-row">
                <mat-form-field appearance="outline" class="adx-full-width">
                    <mat-label>{{ 'ASTIMAX.VMAILBOX.WIDGET.WIDGET_HEADER_DISPLAY_OPTIONS' | translate }}</mat-label>
                    <mat-select [(value)]="selectedWidgetHeaderOption" (selectionChange)="selectHeaderOption($event)">
                        @for (option of (vmailboxWidget.settings.widgetHeader | keyvalue); track option.key) {
                            <mat-option
                                    [value]="option.key"
                                    [disabled]="option.key === 'alwaysOff' || option.key === 'transparent'">
                                {{ getText(option.key) | translate }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- Show widget title toggle -->
            <div class="adx-form-row adx-toggle-row">
                <mat-slide-toggle class="primary" [(ngModel)]="showWidgetTitle">
                    <span class="adx-toggle-label">{{ 'ASTIMAX.VMAILBOX.WIDGET.SHOW_WIDGET_TITLE' | translate }}</span>
                </mat-slide-toggle>
            </div>

        </div>

        <div class="adx-settings-footer">
            <button mat-raised-button
                    type="button"
                    [mat-dialog-close]="true"
                    aria-label="Bearbeitung abbrechen"
                    matTooltip="{{ 'ASTIMAX.VMAILBOX.WIDGET.CANCEL_EDITING' | translate }}">
                {{ "ASTIMAX.VMAILBOX.WIDGET.CANCEL" | translate }}
            </button>
            <button mat-raised-button
                    class="primary"
                    type="submit"
                    (click)="onSubmit()"
                    matTooltip="{{ 'ASTIMAX.VMAILBOX.WIDGET.SAVING_CHANGES' | translate }}">
                {{ "ASTIMAX.VMAILBOX.WIDGET.SAVE" | translate }}
            </button>
        </div>

    </div>
</div>
